import React from 'react';
import './InactivityPopup.scss';
import useAmplifyAuth from "../../../helpers/useAmplifyAuth";

import {useHistory} from "react-router";
import {useTranslation} from "react-i18next";
import Modal from "../Modal/Modal";

const InactivityPopUp = (props) => {
  const {t} = useTranslation();
  const {
    refreshToken,
    handleSignout,
  } = useAmplifyAuth();
  const history = useHistory();

  const signout = () => {
    return handleSignout()
      .then(() => {
        history.push('/login');
      })
  }

  const refreshTokenHandler = () => {
    return refreshToken()
      .then(() => {
        props.refreshed()
      })
  }

  return props.visible ? (
    <div className="inactivity-popup" data-testid="InactivityPopup">
      <Modal
        show={props.visible}
        content={<h1 className="paragraph-main-fs8">{t("inactivity_popup_title")}</h1>}
        type={"button"}
        styleType={"secondary"}
        onFirstClick={signout}
        linkTitle={t("inactivity_popup_btn_end_session")}
        typeSecond={"button"}
        styleTypeSecond={"primary"}
        onSecondClick={refreshTokenHandler}
        linkTitleSecond={t("inactivity_popup_btn_continue")}
      />
    </div>
  ) : null
};


export default InactivityPopUp;
